import HeroSlider, {SELECTORS as HERO_SLIDER_SELECTORS} from '../../../Components/HeroSlider/HeroSlider';

import '../../../Components/HeroSlider/_index.scss';
$(HERO_SLIDER_SELECTORS.root).each((i, element) => {
    new HeroSlider(element);
});